/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Decision used when resolving a Shadow MCP inventory request.
 */
export const ResolveShadowMCPInventoryRequestFormDecision = {
  Allow: "allow",
  Deny: "deny",
} as const;
/**
 * Decision used when resolving a Shadow MCP inventory request.
 */
export type ResolveShadowMCPInventoryRequestFormDecision = ClosedEnum<
  typeof ResolveShadowMCPInventoryRequestFormDecision
>;

export type ResolveShadowMCPInventoryRequestForm = {
  /**
   * Decision used when resolving a Shadow MCP inventory request.
   */
  decision: ResolveShadowMCPInventoryRequestFormDecision;
  policyIds?: Array<string> | undefined;
  projectId: string;
  serverUrl: string;
};

/** @internal */
export const ResolveShadowMCPInventoryRequestFormDecision$outboundSchema:
  z.ZodMiniEnum<typeof ResolveShadowMCPInventoryRequestFormDecision> = z.enum(
    ResolveShadowMCPInventoryRequestFormDecision,
  );

/** @internal */
export type ResolveShadowMCPInventoryRequestForm$Outbound = {
  decision: string;
  policy_ids?: Array<string> | undefined;
  project_id: string;
  server_url: string;
};

/** @internal */
export const ResolveShadowMCPInventoryRequestForm$outboundSchema: z.ZodMiniType<
  ResolveShadowMCPInventoryRequestForm$Outbound,
  ResolveShadowMCPInventoryRequestForm
> = z.pipe(
  z.object({
    decision: ResolveShadowMCPInventoryRequestFormDecision$outboundSchema,
    policyIds: z.optional(z.array(z.string())),
    projectId: z.string(),
    serverUrl: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      policyIds: "policy_ids",
      projectId: "project_id",
      serverUrl: "server_url",
    });
  }),
);

export function resolveShadowMCPInventoryRequestFormToJSON(
  resolveShadowMCPInventoryRequestForm: ResolveShadowMCPInventoryRequestForm,
): string {
  return JSON.stringify(
    ResolveShadowMCPInventoryRequestForm$outboundSchema.parse(
      resolveShadowMCPInventoryRequestForm,
    ),
  );
}
